class InvoiceV2 {
    constructor(invoiceid) {
        this.id = invoiceid
        this.lines
    }

    async addAdditionalData(data) {
        try {
            var r = await $.ajax({
                url: `/n/invoice/v2/${this.id}`,
                contentType: 'application/json',
                method: 'post',
                data: JSON.stringify({
                    id: null,
                    jsonrpc: "2.0",
                    method: "addData",
                    params: [data],
                }),
            })
            return r.result;
        } catch (e) {
            console.log(e);
        }
        return false;
    }

    async addTransaction(paymentItems) {
        try {
            var r = await $.ajax({
                url: `/n/invoice/v2/${this.id}`,
                contentType: 'application/json',
                method: 'post',
                data: JSON.stringify({
                    id: null,
                    jsonrpc: "2.0",
                    method: "addTransaction",
                    params: [paymentItems],
                }),
            })
            return { id: r.result }
        } catch (e) {
            if (e.responseJSON && e.responseJSON.error) {
                switch (e.responseJSON.error.message) {
                    case 'pending abuse check':
                        ShowNotification.fail(translation.get("add_transaction_fail_pending_abuse"))
                        break
                    default:
                }
            }
        }
    }

    async fetchLines() {
        var r = await $.ajax(`/n/invoice/v2/${this.id}`)
        this.lines = r.lines.map((l) => {
            return l.basketItem
        })
    }
}


/*
 * Wraps ordering: generating an invoice for a basket and adding a transaction
 * to it. Both are steps in a checkout the customer has initiated, not things
 * a page does on load, so they should not gate reaching the page that offers
 * the button.
 *
 * @optional /n/invoice/v2
 * @optional /n/invoice/v2/{n}
 */
class V2OrderWrapper {
    constructor(basketRef, subscription = false) {
        this.basketRef = basketRef
        this.invoiceId = null
        this.invoice = null
        this.enableSubscription = subscription
    }

    async generateInvoice() {
        var r = await $.ajax({
            url: `/n/invoice/v2`,
            contentType: 'application/json',
            method: 'post',
            data: JSON.stringify({
                id: null,
                jsonrpc: "2.0",
                method: "add",
                params: [this.basketRef, this.enableSubscription, getCookie("affiliate")],
            }),
        })
        this.invoice = new InvoiceV2(r.result)
        return this.invoice
    }
}
